import styled from "styled-components"
import bgDesktop from "../../assets/bg-desktop.png"
import bgMobile from "../../assets/bg-mobile.png"

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;

  height: 100dvh;
  width: 100vw;
`

export const Main = styled.main`
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: row;
`

export const Background = styled.div`
  flex: 1;
  width: 100%;
  height: 100%;
  background-image: url(${bgDesktop});
  background-size: cover;
  background-position: inherit;

  @media (max-width: 768px) {
    background-image: url(${bgMobile});
    background-size: cover;
    background-position: initial;
  }
`
